// extracted by mini-css-extract-plugin
module.exports = {"MainButton":"MainButton_MainButton__3m-jk","WithArrow":"MainButton_WithArrow__aMWe4"};